import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Box, ListItem, List, Typography, } from '@mui/material';
import { useStore } from '@mcn-platform/models';
import PlaceHolder from '../../portal/common/PlaceHolder';
const renderTree = (category, depth, editData) => (_jsxs(_Fragment, { children: [_jsx(ListItem, { sx: { pl: depth * 2 }, children: _jsx(Link, { to: `hub-${category.type}/${category.id}`, onClick: (ev) => editData && editData.preNavigationHook(`hub-${category.type}/${category.id}`, ev), children: _jsx(Typography, { component: "div", variant: depth === 0 ? 'subtitle1' : 'subtitle2', sx: {
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center', /* align vertical */
                    }, children: category.name }) }) }, category.id), category.subCategories?.map((subCat) => (renderTree(subCat, depth + 1, editData)))] }));
/**
 * Choices for how this works:
 * 1) Always show the root category
 * 2) Show the subcategories of the selected category
 * 3) Show the top level category of the selected category
 * 4) Show specific category
 *
 * @param param0
 * @returns
 */
const HubCategoryNav = ({ editData, configId, }) => {
    const { currentHub: hub } = useStore();
    const rootCategory = hub?.categories[0];
    const isEmpty = () => (!rootCategory);
    if (isEmpty() && editData && editData.activeConfigId !== configId) {
        return _jsx(PlaceHolder, { placeHolderName: "Configure Hub Category Nav" });
    }
    return (_jsx(Box, { sx: { height: '100%', overflow: 'hidden' }, children: _jsx(Box, { sx: {
                height: '100%',
                overflow: 'auto',
            }, children: _jsx(List, { "aria-label": "course sections tree view", sx: {
                    width: '100%',
                    background: (theme) => (theme.palette.subNav.topColor),
                    color: (theme) => (theme.palette.subNav.text.primary),
                    padding: '16px',
                }, children: rootCategory?.subCategories?.map((subCategory) => renderTree(subCategory, 0, editData)) }) }) }));
};
HubCategoryNav.defaultProps = {};
HubCategoryNav.meta = {
    group: 'hub',
    name: 'Hub Category Nav',
    description: 'Shows hub categories.',
    props: [],
    defaultConfig: {
        type: 'component',
        component: 'HubCategoryNav',
    },
};
export default HubCategoryNav;
//# sourceMappingURL=HubCategoryNav.js.map